module.exports = __webpack_public_path__ + "static/img/SearchDetailLogout6.939ce06.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailLogout6.png
// module id = 742
// module chunks = 0